import BaseService from "./base.service";

class RequestsService extends BaseService {
  get entity() {
    return "requests";
  }

  submitExtendingRequest(request) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .post(`${this.entity}/extending`, request)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          // Error
          if (error.response) {
          } else if (error.request) {
          } else {
            console.log("Error", error.message);
          }
        });
    });
  }
}

export default new RequestsService();
